export const DEVICE = {
  Mobile: 'mobile',
  Desktop: 'desktop',
} as const

export type Device = (typeof DEVICE)[keyof typeof DEVICE]

export const DEVICES: Device[] = [DEVICE.Mobile, DEVICE.Desktop]
